import { FileOutput } from '@quadminds/client-apis/agents';
import { useMutation } from '@tanstack/react-query';
import { AxiosProgressEvent } from 'axios';
import ChatService from '../services/chat.service';

const chatService = new ChatService();

/**
 * Custom hook to import documents from a URI using React Query's mutation.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the import.
 */
export const useImportDocumentByUri = () => {
    return useMutation<
        FileOutput, // Return type
        Error, // Error type
        {
            uri: string;
            externalId: string;
            parentId: string | null;
            handleProgressEvent?: (event: AxiosProgressEvent & { name: string }) => void;
        } // Variables type
    >({
        mutationFn: async ({ uri, externalId, parentId, handleProgressEvent }) => {
            if (!uri) {
                throw new Error('URI is required to import a document');
            }
            return await chatService.importDocumentsFromUri(uri, externalId, parentId, handleProgressEvent);
        },
    });
};
